/**
 * 配列関連ユーティリティ
 */
export default {
  /**
   * 子プロパティが有効かどうか
   * （null、undefinedの時が無効）
   *
   * @param array 確認対象の配列（クラスオブジェクトでも可）
   * @param childName 子プロパティ名（カンマ区切りで孫指定可能）
   * @returns true: 有効、false: 無効
   * @example
   *    useChild(this.$store.state.apiShops, 'usageFeeCalc.data.usageFeeCalc')
   */
  useChild (array, childNames) {
    if (array === null || childNames === null) {
      return false
    }

    let childList = childNames.split('.')
    let target = array
    for (let i = 0; i < childList.length; i++) {
      const child = childList[i]

      if (target[child] === undefined) {
        return false
      }

      if (target[child] === null && i < childList.length) {
        return false
      }

      target = target[child]
    }

    return true
  },

  /**
   * ディープクローン
   *
   * @param array 配列
   * @returns クローン
   */
  clone (array) {
    if (array === null) {
      return null
    }
    if (typeof array !== 'object') {
      return array
    } else if (array instanceof Date) {
      return array
    }

    const object = array instanceof Array ? [] : {}
    for (const key in array) {
      if (!array.hasOwnProperty(key)) {
        continue
      }

      const type = array[key] === null ? 'null' : typeof array[key]
      object[key] = type === 'object' ? this.clone(array[key]) : array[key]
    }

    return object
  },

  /**
   * 値比較
   */
  equals (array1, array2) {
    const arrayType1 = array1 === null ? 'null' : typeof array1
    const arrayType2 = array2 === null ? 'null' : typeof array2
    if (arrayType1 !== arrayType2) {
      return false
    }
    if (array1 === null) {
      return true
    }
    if (arrayType1 !== 'object') {
      return array1 === array2
    }

    const keys1 = Object.keys(array1)
    const keys2 = Object.keys(array2)

    if (keys1.length !== keys2.length) {
      return false
    }

    for (const i in keys1) {
      const key = keys1[i]
      if (!keys2.includes(key)) {
        return false
      }
      if (!this.equals(array1[key], array2[key])) {
        return false
      }
    }

    return true
  }
}
